export default "__VITE_ASSET__O0In_NxP__"